/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {

    export function meevoReplaceFilter() {
        const filter = (str: string, from: string, to: string): string => {
            if (typeof str !== 'string') return str;

            const regex = new RegExp(from, 'g');
            return str.replace(regex, to);
        };
        return filter;
    }


    angular.module("meevo.components.filters")
        .filter("meevoReplaceFilter", meevoReplaceFilter);
}
